import { exists, logicalXOR, Module } from '@nu-art/ts-common';
import { PanelKey_AddProtocolData, PanelKey_Home, PanelKey_Inbox, PanelKey_NextSteps, PanelKey_ProvideInfo, PanelKey_Spotlight, ProtocolInteractionType_AddOrder } from '@app/advisor-v5-shared';
import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_Inbox } from './module-inbox/ModuleFE_Inbox.js';
import { dispatch_OnAddProtocol } from '../ui/panels/AdvisorPanel_AddProtocolData/renderers/Renderer_AddProtocol/dispatchers.js';
import { ModuleFE_Spotlight } from './ModuleFE_Spotlight/index.js';
import { ModuleFE_ProvideInfo } from './provide-info/ModuleFE_ProvideInfo.js';
import { ModuleFE_ProtocolInteraction } from '../_enum/protocol-interaction/index.js';
import { contextCloseMode_Force, contextCloseMode_Safe } from './provide-info/types.js';
const dispatcher_AdvisorMini = new ThunderDispatcher('__onAdvisorMiniChange');
export const miniBreakPoint = 1000;
class ModuleFE_AdvisorMini_Class extends Module {
    __onWindowResized = () => {
        const shouldBeMini = this.shouldMiniBeActive();
        //Mini state is changing
        if (logicalXOR(shouldBeMini, this.isMiniActive)) {
            this.isMiniActive = shouldBeMini;
            //Switching out of mini, announce changes through defaulting to welcome
            if (this.currentFocusedPanel !== PanelKey_Home) {
                this.openPanel(PanelKey_Home);
            }
            else {
                dispatcher_AdvisorMini.dispatchUI();
            }
            //Either way, clear spotlight data and nav mode for stability
            if (ModuleFE_Spotlight.getSpotlightData())
                ModuleFE_Spotlight.closeSpotlight();
        }
    };
    //######################### Properties #########################
    currentFocusedPanel;
    isMiniActive = this.shouldMiniBeActive();
    //######################### Private Functionality #########################
    //Actions needed to take in order to correctly close the current panel
    closePanel = {
        [PanelKey_Inbox]: () => {
            //Clear selected item
            ModuleFE_Inbox.setSelectedInboxItem();
        },
        [PanelKey_NextSteps]: (nextPanelKey) => {
            //Clear current interaction if the next key isn't add-protocol-data
            if (nextPanelKey === PanelKey_AddProtocolData)
                return;
            ModuleFE_ProtocolInteraction.closeInteraction();
        },
        [PanelKey_AddProtocolData]: () => {
            const currentInteraction = ModuleFE_ProtocolInteraction.getInteraction();
            if (currentInteraction?.type === ProtocolInteractionType_AddOrder)
                return ModuleFE_ProtocolInteraction.closeInteraction();
            dispatch_OnAddProtocol.dispatchUI();
        },
        [PanelKey_Spotlight]: () => {
            ModuleFE_Spotlight.closeSpotlight();
        },
        [PanelKey_ProvideInfo]: () => {
            setTimeout(() => ModuleFE_ProvideInfo.context.chain.close(contextCloseMode_Force), 300);
        }
    };
    openPanelInterrupt = {
        [PanelKey_ProvideInfo]: (continueCB) => {
            ModuleFE_ProvideInfo.context.chain.close(contextCloseMode_Safe, continueCB);
        }
    };
    shouldMiniBeActive() {
        const windowWidth = window.innerWidth;
        return windowWidth <= miniBreakPoint;
    }
    //######################### Public Functionality #########################
    getCurrentFocusedPanel = () => {
        if (!this.currentFocusedPanel)
            this.currentFocusedPanel = PanelKey_Home;
        return this.currentFocusedPanel;
    };
    openPanel = (panelKey) => {
        if (this.currentFocusedPanel === panelKey)
            return;
        const currentPanelKey = this.getCurrentFocusedPanel();
        const openPanelCB = () => {
            this.closePanel[currentPanelKey]?.(panelKey);
            this.currentFocusedPanel = panelKey;
            dispatcher_AdvisorMini.dispatchUI();
        };
        if (exists(this.openPanelInterrupt[currentPanelKey]))
            return this.openPanelInterrupt[currentPanelKey](openPanelCB);
        openPanelCB();
    };
    getIsMiniActive = () => this.isMiniActive;
}
export const ModuleFE_AdvisorMini = new ModuleFE_AdvisorMini_Class();
//# sourceMappingURL=ModuleFE_AdvisorMini.js.map